
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import { getLocal, localClear, setLocal } from "../utils/localStorageOps";
import { Api } from "./api";

const token = getLocal('token');
const provider = getLocal("iduser");
const zoop_id = getLocal("userzoop");
const isAssociado = getLocal('associado');
const associado_id = getLocal('associado_id');
const userInfo = getLocal("token") ? jwtDecode(getLocal("token")) : {}

async function handleToggleUser(userId) {
  if (!userInfo.super_usuario) return null;

  try {
    const { data } = await Api.get(`/users/acessoSuper/${userId}`);
    setLocal("iduser", userId)
    setLocal("token", data.token);
    window.location.reload(false);
  } catch (err) {
    console.log(err);
  }
}

async function getUserIp() {
  try {
    const { data } = await Api.get("/ip");

    return(data.ip)
  } catch (err) {
    console.error(err);
  }
}

function logoutExpiracao(){
  if(window.location.pathname.startsWith('/dashboard')){
    toast.error("Seu token expirou, faça login novamente")
    localClear();
    window.location.href = '/login'
  }
}

export { associado_id, getUserIp, handleToggleUser, isAssociado, logoutExpiracao, provider, token, userInfo, zoop_id };

